import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import type { Service } from 'webapp-types';

import CustomQuerySetupApiMetricBuilderGeneralSettingsComponent from 'webapp/components/custom-query/setup/api-metric-builder/general-settings';
import type { Args } from 'webapp/components/custom-query/setup/wizard/api-metric-builder/step-common';
import CustomQuerySetupWizardSheetControlsComponent from 'webapp/components/custom-query/setup/wizard/sheet/controls';
import FormErrorComponent from 'webapp/components/form-error';

interface CustomQuerySetupWizardSheetStepRequestComponentInterface {
	Args: Args;
	Blocks: { default: [] }; // this is needed for yield
}

export default class CustomQuerySetupWizardApiMetricBuilderStepRequestComponent extends Component<CustomQuerySetupWizardSheetStepRequestComponentInterface> {
	@service('navigation') declare navigationService: Service.Navigation;

	@tracked submitInProgress = false;

	get theme() {
		return this.navigationService.theme.id;
	}

	@action
	goNext(): void {
		const form = this.args.form;

		void form.validate();

		if (!form.isValid) {
			return;
		}

		this.submitInProgress = true;
		void form
			.getRawData()
			.then(() => {
				if (form.rawData) {
					this.args.goNext();
				}
			})
			.finally(() => {
				this.submitInProgress = false;
			});
	}

	@action
	onContentChange(): void {
		// skip
	}
	<template>
		<div class="step-ct">

			<div class="top">

				<h3>Prepare API request</h3>

				<div class="source-info">
					<img
						class="avatar"
						src={{@model.sourceObj.realAvatar}}
						alt={{@model.sourceObj.sourceType.name}}
					/>
					<div>
						<div class="t">{{@model.sourceObj.title}}</div>
						<span>{{@model.sourceObj.sourceType.name}}</span>
					</div>
				</div>

				{{yield}}
				{{! .toggle-manual button }}
			</div>

			<FormErrorComponent @errors={{@form.errors}} />

			<CustomQuerySetupApiMetricBuilderGeneralSettingsComponent
				@form={{@form}}
				@isDisabled={{this.submitInProgress}}
				@onContentChange={{this.onContentChange}}
				@groupAdvanced={{false}}
				@theme={{this.theme}}
				@goNext={{this.goNext}}
			/>

		</div>

		{{! controlsNode could still be unrendered }}
		{{#if @controlsNode}}
			{{#in-element @controlsNode}}
				<CustomQuerySetupWizardSheetControlsComponent
					@showBack={{false}}
					@isButtonDisabled={{false}}
					@submitInProgress={{this.submitInProgress}}
					@goNext={{this.goNext}}
					@goPrevious={{@goPrevious}}
				/>
			{{/in-element}}
		{{/if}}
	</template>
}
